<template>
	<section id="intro" class="main-content intro">
		<div class="row">
			<slot name="content">
				<div class="columns" :class="!introductionContent.length ? 'column12 align-center' : 'column6'">
					<div class="title-reverse-wrapper">
						<h1>{{ title }}</h1>
						<h2 class="subtitle" :class="!subtitle.length && 'no-after'">{{ subtitle }}</h2>
					</div>
					<div v-parse-links v-html="content" />
				</div>
				<div class="columns column6">
					<slot name="extra-content" />
					<div
						v-if="introductionContent.length"
						v-parse-links
						class="intro-content"
						v-html="introductionContent"
					/>
				</div>
			</slot>
		</div>
	</section>

	<slot />
</template>

<script setup>
defineProps({
	title: { type: String, default: '' },
	subtitle: { type: String, default: '' },
	introductionContent: { type: String, default: '' },
	content: { type: String, default: '' },
});
</script>

<style lang="scss" scoped>
.row {
	display: flex;
	flex-flow: row wrap;
	justify-content: center;
	align-items: flex-start;

	.column6:first-child {
		margin-top: 5px;
	}

	.align-center h1,
	.align-center h2 {
		margin-left: auto;
		margin-right: auto;
	}
}
</style>
